module.exports = __webpack_public_path__ + "img/home_bgv2.74410918.png";